import {
  Building2,
  ExternalLink,
  LifeBuoy,
  Mail,
  ShieldCheck,
} from 'lucide-react';
import { canAccessTenantManagement } from '../../../auth/roles';
import { useAuth } from '../../../auth/useAuth';
import { useI18n } from '../../../i18n/useI18n';

const COMPANY_EMAIL = 'info@liks.gmbh';
const COMPANY_EMAIL_HREF = 'mailto:info@liks.gmbh';
const SUPPORT_PORTAL_LABEL = 'JIRA';
const SUPPORT_PORTAL_URL =
  'https://oncite.atlassian.net/servicedesk/customer/portal/2169';
const PRIVACY_POLICY_URL = 'https://liks.gmbh/datenschutz';

export function SettingsAboutTab() {
  const { user } = useAuth();
  const { translate } = useI18n();
  const showSupportPortal = canAccessTenantManagement(user);

  return (
    <div className="settings-page__about-tab">
      <section className="settings-about-card">
        <header className="settings-about-card__header">
          <span
            className="settings-about-card__icon settings-about-card__icon--company"
            aria-hidden
          >
            <Building2 strokeWidth={2} />
          </span>
          <div className="settings-about-card__heading">
            <h2 className="settings-about-card__title">
              {translate('settings.about.company.title')}
            </h2>
            <p className="settings-about-card__subtitle">
              {translate('settings.about.company.subtitle')}
            </p>
          </div>
        </header>

        <div className="settings-about-card__body settings-about-card__body--columns">
          <address className="settings-about-card__address">
            <span>{translate('settings.about.company.street')}</span>
            <span>{translate('settings.about.company.city')}</span>
            <span>{translate('settings.about.company.country')}</span>
          </address>
          <dl className="settings-about-card__registry">
            <div>
              <dt>{translate('settings.about.company.courtLabel')}</dt>
              <dd>{translate('settings.about.company.courtValue')}</dd>
            </div>
            <div>
              <dt>{translate('settings.about.company.registerLabel')}</dt>
              <dd>{translate('settings.about.company.registerValue')}</dd>
            </div>
            <div>
              <dt>{translate('settings.about.company.vatLabel')}</dt>
              <dd>{translate('settings.about.company.vatValue')}</dd>
            </div>
          </dl>
        </div>

        <div className="settings-about-card__footer">
          <a
            className="liks-button liks-button--secondary settings-about-card__contact"
            href={COMPANY_EMAIL_HREF}
          >
            <Mail aria-hidden strokeWidth={2} />
            <span>{COMPANY_EMAIL}</span>
          </a>
          {showSupportPortal && (
            <a
              className="liks-button liks-button--secondary settings-about-card__contact"
              href={SUPPORT_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LifeBuoy aria-hidden strokeWidth={2} />
              <span>{SUPPORT_PORTAL_LABEL}</span>
            </a>
          )}
        </div>
      </section>

      <section className="settings-about-card">
        <header className="settings-about-card__header">
          <span
            className="settings-about-card__icon settings-about-card__icon--privacy"
            aria-hidden
          >
            <ShieldCheck strokeWidth={2} />
          </span>
          <div className="settings-about-card__heading">
            <h2 className="settings-about-card__title">
              {translate('settings.about.privacy.title')}
            </h2>
            <p className="settings-about-card__subtitle">
              {translate('settings.about.privacy.subtitle')}
            </p>
          </div>
        </header>

        <div className="settings-about-card__body">
          <p className="settings-about-card__text">
            {translate('settings.about.privacy.body')}
          </p>
        </div>

        <div className="settings-about-card__footer">
          <a
            className="liks-button liks-button--primary settings-about-card__privacy-link"
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ShieldCheck aria-hidden strokeWidth={2} />
            <span>{translate('settings.about.privacy.readPolicy')}</span>
            <ExternalLink aria-hidden strokeWidth={2} />
          </a>
        </div>
      </section>
    </div>
  );
}
